var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2261_1630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.609 95.8569L223.147 101.546L160.427 184.461L109.938 109.226L64.8538 175.217L32.8538 146.772L42.6671 135.466L61.8671 152.461L109.938 82.2036L161.067 158.364L208.427 95.7147C201.252 95.1087 194.275 93.0444 187.926 89.648C181.576 86.2516 175.986 81.5948 171.499 75.9626C167.012 70.3305 163.722 63.8416 161.83 56.8935C159.939 49.9453 159.485 42.6841 160.498 35.5547H28.4449C24.6729 35.5547 21.0554 37.0531 18.3882 39.7203C15.7211 42.3875 14.2227 46.0049 14.2227 49.7769V206.221C14.2227 209.993 15.7211 213.611 18.3882 216.278C21.0554 218.945 24.6729 220.444 28.4449 220.444H227.556C231.328 220.444 234.945 218.945 237.613 216.278C240.28 213.611 241.778 209.993 241.778 206.221V87.7502C233.917 92.7001 224.892 95.4958 215.609 95.8569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.333 78.2224C232.97 78.2224 248.888 62.3037 248.888 42.6669C248.888 23.0301 232.97 7.11133 213.333 7.11133C193.696 7.11133 177.777 23.0301 177.777 42.6669C177.777 62.3037 193.696 78.2224 213.333 78.2224Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2261_1630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.91aac83fbad439b6d247212cad0d99e6.svg";
export { ForwardRef as ReactComponent };